module.exports = __webpack_public_path__ + "img/telegram.a879e582.svg";